var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Listing } from '../../classes/listing';
import { HasSubscriptions } from '../has-subscriptions';
import { SavedSearch } from '../../classes/saved-search';
import { SavedSearchLocationType } from '../../classes/enums';
import { CommunicationService } from '../../services/communication.service';
import { CredentialsService } from '../../services/credentials.service';
import { TranslateService } from '@ngx-translate/core';
import { InputComponent } from '../../components/forms/input/input.component';
import { PreferencesService } from '../../services/preferences.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService } from '../../services/confirmation/confirmation.service';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { NOTIFICATION_CHECKBOX_VALUE } from '../../classes/analytics-tags';
var SaveSearchComponent = /** @class */ (function (_super) {
    __extends(SaveSearchComponent, _super);
    function SaveSearchComponent(preferencesService, communicationService, credentialsService, translateService, fb, confirmationSerice, router, domManipulationService, _analyticsService) {
        var _this = _super.call(this) || this;
        _this.preferencesService = preferencesService;
        _this.communicationService = communicationService;
        _this.credentialsService = credentialsService;
        _this.translateService = translateService;
        _this.fb = fb;
        _this.confirmationSerice = confirmationSerice;
        _this.router = router;
        _this.domManipulationService = domManipulationService;
        _this._analyticsService = _analyticsService;
        _this.SavedSearchLocationType = SavedSearchLocationType;
        _this.closed = new EventEmitter();
        _this.hasError = {
            duplicateName: false
        };
        _this.submitted = false;
        _this.savedSearches = [];
        _this.SavedSearch = SavedSearch;
        _this.saveSearchForm = _this.fb.group({
            name: ['', [Validators.required]],
            notification: [false],
        });
        return _this;
    }
    SaveSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.selectedSaveSearch.subscribe(function (s) {
            if (s) {
                _this.saveSearchForm.setValue({ name: s.name });
                _this.saveSearchForm.setValue({ notification: s.notificationsEnabled || false });
            }
        }));
        this.preferencesService.savedSearchesChanged.subscribe(function (s) { return _this.savedSearches = s; });
        this.domManipulationService.focus(this.inputComponent.inputRef);
    };
    SaveSearchComponent.prototype.ngOnChanges = function (changes) { };
    SaveSearchComponent.prototype.onSubmit = function () {
        var _this = this;
        var name = this.saveSearchForm.get('name').value;
        var notification = this.saveSearchForm.get('notification').value;
        // No duplicate names allowed for searches
        if (this.preferencesService.doesSavedSearchExist(name)) {
            this.hasError.duplicateName = true;
            return;
        }
        this.hasError.duplicateName = false;
        if (this.listing != null) {
            this.preferencesService.addSavedSearchOffMarket(name, notification, this.listing).then(function (s) {
                _this.saveSearchedCompleted(s, name, notification);
            });
        }
        else {
            this.preferencesService.addSavedSearch(name, notification).then(function (s) {
                _this.saveSearchedCompleted(s, name, notification);
            });
        }
    };
    SaveSearchComponent.prototype.saveSearchedCompleted = function (s, name, notification) {
        var _this = this;
        this.communicationService.selectedSaveSearch.next(s);
        // TODO: maybe make this an object with bottom passed in
        this.communicationService.notifications.bottomNotification.next(this.translateService.instant('actions.add-saved-search', { x: name }));
        this.submitted = true;
        this._analyticsService.eventTrack(NOTIFICATION_CHECKBOX_VALUE, s.notificationsEnabled);
        this.closed.emit();
        this.addSub(this.credentialsService.isLoggedIn
            .subscribe(function (isAuthenticated) {
            if (!isAuthenticated && notification) {
                _this.router.navigate(['/', { outlets: { popup: 'register-login' } }]);
            }
        }));
    };
    SaveSearchComponent.prototype.updateSavedSearch = function (s) {
        var _this = this;
        if (this.confirmationSerice.showConfirmation(this.translateService.instant('drawer.save-search.confirm-update', { x: s.name }))) {
            this.preferencesService.updateSavedSearch(s).then(function (search) {
                _this.closed.emit();
                _this.communicationService.notifications.bottomNotification.next(_this.translateService.instant('actions.update-saved-search', { x: s.name }));
                _this.communicationService.selectedSaveSearch.next(search);
            }).catch(function () {
                // TODO: errors
            });
        }
    };
    return SaveSearchComponent;
}(HasSubscriptions));
export { SaveSearchComponent };
